import React from 'react';
import { Link } from 'react-router-dom'; // Assuming React Router
import { FaUsers, FaHandshake, FaChartLine, FaGlobe, FaAward, FaRegLightbulb } from 'react-icons/fa';
import Footer from '../component/Footer';
import Navbar from '../component/Navbar';

// Theme colors
const primaryBlue = 'rgb(43, 147, 208)';
const yellowAccent = '#fbbf24';

// Membership Types Data
const membershipTypes = [
  {
    title: 'General Members',
    description:
      'Any Government Organisations, Small Business Authorities, Autonomous bodies, Financial Institutions, Chambers of Commerce and Industry, MSME Associations, Training Institutes, Consultancy Organisations, Technology Providers',
    icon: <FaUsers className="text-3xl" />,
    delay: '0.1s',
  },
  {
    title: 'Associate Members',
    description:
      'Any Individuals, Enterprises, Corporations, Stakeholders, Research Institutions, Large Enterprises, Academicians, Consultants etc. engaged in MSME sector.',
    icon: <FaHandshake className="text-3xl" />,
    delay: '0.3s',
  },
  {
    title: 'Permanent Members',
    description:
      'Any General Member or Associate Member who contribute to the funds of the organization.',
    icon: <FaAward className="text-3xl" />,
    delay: '0.5s',
  },
];

// Benefits Data
const benefits = [
  {
    number: '#1',
    title: 'Enterprise Support',
    description:
      'Expert guidance and assistance for starting new business, Improving existing businesses, Skill development and entrepreneurship development, Business matching, International Experts search.',
    icon: <FaChartLine />,
  },
  {
    number: '#2',
    title: 'Information Assistance',
    description:
      'Basic business related laws, Business legislation, trade regulations, Public Policy, Taxation, Available MSME support by different stakeholders.',
    icon: <FaGlobe />,
  },
  {
    number: '#3',
    title: 'Participation & Knowledge Support',
    description:
      'Participation in WASME’s National/International conferences and seminars, workshops, training and programmes etc.',
    icon: <FaRegLightbulb />,
  },
  {
    number: '#4',
    title: 'Liaisoning Support',
    description:
      'Facilitating network and liaison support to aspiring entrepreneurs and start-ups in establishing their business in different country as well as our member countries across the world.',
    icon: <FaHandshake />,
  },
  {
    number: '#5',
    title: 'Branding Opportunity',
    
    description:
      'Sponsorship and Volunteering, advertising opportunities in our events and programs, newsletters, websites, e-bulletins, publications etc.',
    icon: <FaAward />,
  },
  {
    number: '#6',
    title: 'Exposure visit to Global Members',
    description:
      'Facilitate exposure visit at national and international organizations, institutes, research centres etc.',
    icon: <FaGlobe />,
  },
];

const MembershipPage = () => {
  return (
    <>
    <Navbar/>
       <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Hero Section */}
        <section className="relative mb-20">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                Become Our <span style={{ color: primaryBlue }}>Member</span>
              </h1>
              <p className="text-gray-600 text-lg leading-relaxed mb-6 text-justify">
                WASME has provided high-quality services to its members since its foundation. Our membership gives us
                access to all of WASME’s resources, including the ability to participate in its activities, participate in
                national, regional and worldwide programmes and receive publications, circulars, literature and papers. Our
                members support WASME’s purpose of advancing, promoting and supporting MSMEs in their individual countries
                through partnerships and collaborations with local government bodies, regional authorities, international
                links, civil society and MSMEs. WASME has been a catalyst in the establishment of MSMEs in several nations
                by facilitating linkage support, networking, the establishment of industrial units, registration and
                taxation, among other things.
              </p>
              <Link
                to="/MembershipForm"
                className="inline-flex items-center px-6 py-3 rounded-lg text-white font-medium hover:opacity-90 transition-opacity shadow-md"
                style={{ backgroundColor: primaryBlue }}
              >
                Membership Form
                <svg
                  className="w-5 h-5 ml-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Link>
            </div>
            <div className="order-1 lg:order-2 flex justify-center">
              <div className="relative">
                <div
                  className="absolute -top-4 -left-4 w-24 h-24 rounded-full opacity-20"
                  style={{ backgroundColor: yellowAccent }}
                ></div>
                <div
                  className="absolute -bottom-4 -right-4 w-32 h-32 rounded-full opacity-20"
                  style={{ backgroundColor: primaryBlue }}
                ></div>
                <img
                  src="/img/membership.png"
                  alt="Become a Member"
                  className="relative rounded-2xl shadow-xl object-cover w-full max-w-md border-4 border-white"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Membership Types */}
        <section className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-3">Membership Categories</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Choose the membership that best fits your organization or individual goals.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {membershipTypes.map((type, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 group"
              >
                <div className="h-2" style={{ backgroundColor: primaryBlue }}></div>
                <div className="p-6">
                  <div
                    className="w-14 h-14 rounded-xl flex items-center justify-center mb-4"
                    style={{ backgroundColor: primaryBlue + '20', color: primaryBlue }}
                  >
                    {type.icon}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{type.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{type.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Benefits Section */}
        <section>
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-3">Key Benefits of WASME Membership</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Exchange of best practices in different segments of industries and empower the growth of SMEs to achieve
              competitive advantage in global market scenario.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 p-6 flex items-start space-x-4"
              >
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center mb-4"
                  style={{ backgroundColor: primaryBlue + '10', color: primaryBlue }}
                >
                  {benefit.icon}
                </div>
                <div className="flex-1">
                  <div className="flex items-center mb-2">
                    {/* <span
                      className="text-sm font-semibold px-2 py-1 rounded-full mr-2"
                      style={{ backgroundColor: yellowAccent, color: '#1e3a8a' }}
                    >
                      {benefit.number}
                    </span> */}
                    <h3 className="text-lg font-bold text-gray-900">{benefit.title}</h3>
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed">{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Call to Action */}
        <section className="mt-20 text-center">
          <div className="bg-gradient-to-r from-sky-600 to-sky-700 rounded-3xl p-12 text-white">
            <h2 className="text-3xl font-bold mb-4">Ready to Join WASME?</h2>
            <p className="text-lg opacity-90 mb-6 max-w-2xl mx-auto">
              Become part of a global network dedicated to MSME development and growth.
            </p>
            <Link
              to="/MembershipForm"
              className="inline-flex items-center px-6 py-3 rounded-lg bg-white text-sky-600 font-medium hover:bg-gray-100 transition-colors shadow-lg"
            >
              Apply for Membership
              <svg
                className="w-5 h-5 ml-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Link>
          </div>
        </section>
      </main>

    
    </div>
    <Footer/>
    </>
 
  );
};

export default MembershipPage;